import { Button, Space } from 'antd'
import {
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons'

type ViewerToolbarProps = {
  scale: number
  onZoom: (delta: number) => void
  onRotateLeft: () => void
  onRotateRight: () => void
  isFlipped: boolean
  onFlip: () => void
}

export const ViewerToolbar = ({
  scale,
  onZoom,
  onRotateLeft,
  onRotateRight,
  isFlipped,
  onFlip,
}: ViewerToolbarProps) => (
  <Space style={{ display: 'flex', justifyContent: 'center' }}>
    <Button icon={<RotateLeftOutlined />} onClick={onRotateLeft} />
    <Button icon={<RotateRightOutlined />} onClick={onRotateRight} />
    <Button
      icon={<SwapOutlined />}
      type={isFlipped ? 'primary' : 'default'}
      title="Flip horizontally"
      onClick={onFlip}
    />
    <Button
      icon={<ZoomOutOutlined />}
      disabled={scale <= 0.25}
      onClick={() => onZoom(-0.25)}
    />
    <Button
      icon={<ZoomInOutlined />}
      disabled={scale >= 3}
      onClick={() => onZoom(0.25)}
    />
  </Space>
)
